(function () {
  'use strict';

  /**
   * resolved by router: overview, paymentInfo
   */
  angular.module('eclipseApp.myAccount')

    .controller('wirelessHomeCtrl', [
      '$scope',
      '$state',
      '$rootScope',
      '$stateParams',
      'uteModal',
      'uteLocale',
      'commonService',
      'lostStolenDeviceService',
      'env',
      'permissionsService',
      'pricePlanInitiation',
      '$log',
      'dtmService',
      'dtmServiceConstants',
      '$window',
      'brtSwitchCMS',
      'wirelessDashboardService',
      'dataLayerService',
      'manageDataService',
      function ($scope,
                $state,
                $rootScope,
                $stateParams,
                uteModal,
                uteLocale,
                commonService,
                lostStolenDeviceService,
                env,
                permissionsService,
                pricePlanInitiation,
                $log,
                dtmService,
                dtmServiceConstants,
                $window,
                brtSwitchCMS,
                wirelessDashboardService,
                dataLayerService,
                manageDataService) {
        var wdCtrl = this;
        var accountDetails;
        var selectedAccount;
        wdCtrl.showAddData = false;

        init();

        function init() {
          console.log('init is running ...');

          wdCtrl.changeCallerId = wirelessDashboardService.openChangeCallerId;
          wdCtrl.eligibiltyResponseReady = false;
          wdCtrl.legacy = $stateParams.legacy;
          wdCtrl.language = uteLocale.language;
          wdCtrl.voiceMailIndicator = false; // this value can be changed in my-device directive
          commonService.deepLinkState = '';
          wdCtrl.ppcPermitted = false; // hide PPC flow unless allowed by BRT switch
          wdCtrl.hupPermitted = false;
          wdCtrl.dialRefreshed = false;

          pricePlanInitiation.checkBFAPermission()
            .then(function (pagePermitted) {
              wdCtrl.ppcPermitted = pagePermitted.ppc;
              wdCtrl.hupPermitted = pagePermitted.hup;
            })
            .catch(function (error) {
              var err = error instanceof Error ? error : JSON.stringify(error, null, 2);

              $log.error('Error getting ppc permission : ', err);
              $window._satellite.setVar('error', 'PPC | PPC eligibilty error');
              $window._satellite.track('bfa-ppc-error');
              wdCtrl.ppcPermitted = false;
              wdCtrl.hupPermitted = false;
            });

          if ($stateParams.accountNumber && $stateParams.subscriberNo) {
            $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
            $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
          } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
            $state.go('myAccount.overview');
          } else {
            if (!$stateParams.accountNumber) {
              $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
            }
            if (!$stateParams.subscriberNo) {
              $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
            }
          }

          accountDetails = commonService.accountDetails;
          selectedAccount = $stateParams.accountNumber;
          wdCtrl.isAccountHolder = !($rootScope.userInfo.profileType.subscriber);
          wdCtrl.isOwner = $rootScope.userInfo.profileType.owner;
          wdCtrl.isGroupId = $rootScope.userInfo.profileType.groupId;
          wdCtrl.lostDeviceStatus = false;
          wdCtrl.losEnabled = false;
          var ctnList = [];

          for (var i = 0; i < accountDetails.length; i++) {
            if (accountDetails[i].accountNumber === selectedAccount) {
              wdCtrl.billingCycleInfo = accountDetails[i].nextCycleDueIn;
              // viewFidoRewardsBeanService.setBillingCycleDate(accountDetails[i].billCycleDate);
              // viewFidoRewardsBeanService.setLob(accountDetails[i].LOB);
              wdCtrl.billingProvince = accountDetails[i].billingProvince;
              if (wdCtrl.billingProvince.toLowerCase() === 'qc') {
                wdCtrl.billingProvince = 'PQ';  //reset QC province value
              }
              lostStolenDeviceService.setContactEmail(accountDetails[i].contactEmail);
              lostStolenDeviceService.setAccountNumber(accountDetails[i].accountNumber);
              wdCtrl.losEnabled = accountDetails[i].losEnabled;
              for (var j = 0; j < accountDetails[i].subscriberServices.length; j++) {
                _.forEach(accountDetails[i].subscriberServices[j], function (value, key) {
                  if (key === 'wireless') {
                    ctnList.push(value.subscriberNo);
                    if (value.subscriberNo === $stateParams.subscriberNo) {
                      if (value.subscriberStatus && value.subscriberStatus.toLowerCase() === 'suspended' && value.reason.toLowerCase() === 'los') {
                        wdCtrl.lostDeviceStatus = true;
                        lostStolenDeviceService.setReactivateNumber($stateParams.subscriberNo);
                      } else {
                        lostStolenDeviceService.setSelectedFido($stateParams.subscriberNo);
                      }
                    }
                  }
                });
              }
            }
          }

          wdCtrl.ctnList = ctnList;
          manageDataService.setCTNList(ctnList); // DC-1497,set CTN list for data management page
          wdCtrl.selectedCTN = $stateParams.subscriberNo;
          wdCtrl.selectedBan = $stateParams.accountNumber;
          $window.sessionStorage.setItem('addDataSelectedCTN', wdCtrl.selectedCTN); // DC-1474 set current selected CTN in localstorage for add data buy flow
          $window.sessionStorage.setItem('addDataSelectedBAN', wdCtrl.selectedBan); // DC-1474 set current selected BAN in localstorage for add data buy flow

          //FUSS-2096 DTM changes for CTN
          dtmService.setVar(dtmServiceConstants.dtmRules.selectedCTN.parameterName, wdCtrl.selectedCTN);
          dtmService.direct(dtmServiceConstants.dtmRules.selectedCTN.ruleName);


          if (wdCtrl.legacy) {
            wdCtrl.eligibiltyResponseReady = true;
          } else {
            if (permissionsService.permissionDetail.FIDO_UEP) {
              var refreshedCTN = [];
              if ($window.localStorage.getItem('usageRefresh')) {
                refreshedCTN = JSON.parse($window.localStorage.getItem('usageRefresh'));
              }
              if (permissionsService.permissionDetail.isFidoDisableAllUsage && _.indexOf(refreshedCTN, $rootScope.userInfo.selectedSubscriberNo) === -1) {
                wdCtrl.realTimeUsageData = [];
                wdCtrl.legacy = false;
                wdCtrl.eligibiltyResponseReady = true;
                //return; //returning in middle of init function?!
              } else {
                wirelessDashboardService.getDataUsageDetails(wdCtrl.selectedBan, wdCtrl.selectedCTN)
                  .then(function (response) {
                    var data = response.data;
                    if (data && data.content && data.content.isRealTimeEligible) {
                      wdCtrl.realTimeUsageData = data.content;
                      wdCtrl.legacy = false;
                    } else {
                      wdCtrl.legacy = true;
                    }
                    wdCtrl.eligibiltyResponseReady = true;
                  }).catch(function (response) {
                  console.log('IUM Eligibility failed', response.data);
                  //TODO the flag must be false , it's just for testing propose
                  wdCtrl.legacy = true;
                  wdCtrl.eligibiltyResponseReady = true;

                  var AnalyticsDataLayer = {
                    'errors': [
                      {
                        'type': 'http',
                        'category': 'self serve',
                        'message': 'User is not eligible to view real time usage',
                        'field': '',
                        'code': '500',
                        'API': 'uep/v1/dataUsageDetails'
                      }
                    ],
                    'events': {
                      'error': true
                    }
                  };
                  dataLayerService.trackDataLayer(AnalyticsDataLayer);
                });
              }
            } else {
              wdCtrl.legacy = true;
              wdCtrl.eligibiltyResponseReady = true;
            }
          }

          //added for accessibility remediation keyboard event handling for usage circles
          setTimeout(function () {
            $('div.serviceWrap').bind('keydown', function (event) {
              if (event.which === 13) {
                this.click();
              }
            });
            $('div.closingTongue').bind('keydown', function (event) {
              if (event.which === 13) {
                this.click();
              }
            });
          }, 3000);
        }

        wdCtrl.initiatePricePlanChange = function (fromRealtimeDashboard) {
          wdCtrl.showLoader = true;
          wirelessDashboardService.initPPC(wdCtrl.selectedBan, wdCtrl.selectedCTN, fromRealtimeDashboard)
            .finally(function () {
              wdCtrl.showLoader = false;
            });
        };

        wdCtrl.initiateUpgradeMyDevice = function () {
          wdCtrl.showLoader = true;
          wirelessDashboardService.initHUP(wdCtrl.selectedBan, wdCtrl.selectedCTN)
            .finally(function () {
              wdCtrl.showLoader = false;
            });
        };

        wdCtrl.changeCtn = function () {
          $state.go('myAccount.wireless', {
            'accountNumber': wdCtrl.selectedBan,
            'subscriberNo': wdCtrl.selectedCTN
          });
        };

        wdCtrl.broadcastPlanData = function () {
          //TODO: it seems pricePlanDataUsageFetched is not being used elsewhere! - remove it after more investigation
          //$rootScope.$broadcast('pricePlanDataUsageFetched', {plan_data: wdCtrl.pricePlanDataUsage});
        };

        wdCtrl.refreshDial = function () {
          var refreshedCTN = [];
          if ($window.localStorage.getItem('usageRefresh')) {
            refreshedCTN = JSON.parse($window.localStorage.getItem('usageRefresh'));
          }
          refreshedCTN.push($rootScope.userInfo.selectedSubscriberNo);
          $window.localStorage.setItem('usageRefresh', JSON.stringify(refreshedCTN));
          wirelessDashboardService.getDataUsageDetails(wdCtrl.selectedBan, wdCtrl.selectedCTN)
            .then(function (response) {
              var data = response.data;
              if (data && data.content && data.content.isRealTimeEligible) {
                wdCtrl.realTimeUsageData = data.content;
                wdCtrl.legacy = false;
                wdCtrl.dialRefreshed = true;
              } else {
                wdCtrl.legacy = true;
              }
              wdCtrl.eligibiltyResponseReady = true;
            })
            .catch(function (response) {
              console.log('IUM Eligibility failed', response.data);
              //TODO the flag must be false , it's just for testing propose
              wdCtrl.legacy = true;
              wdCtrl.eligibiltyResponseReady = true;

              var AnalyticsDataLayer = {
                'errors': [
                  {
                    'type': 'http',
                    'category': 'self serve',
                    'message': 'User is not eligible to view real time usage',
                    'field': '',
                    'code': '500',
                    'API': 'uep/v1/dataUsageDetails'
                  }
                ],
                'events': {
                  'error': true
                }
              };
              dataLayerService.trackDataLayer(AnalyticsDataLayer);
            });
        };

        //this function is being called from translation files!!
        $scope.startingAtPrice = function () {
          uteModal.open({
            templateUrl: 'modules/my-account/wireless/rlh-cms-content.html',
            size: 'lg',
            controller: ['$scope', function ($scope) {
              $scope.isAsterisk = true;
            }]
          });
        };

      }]);
})();
